<template>
  <div class="vm-list-vue-results">
    <h4>{{ heading }}</h4>
    <hr>
    <div v-if="data.pagination_html" v-html="data.pagination_html"></div>

    <div class="vm-detail-shell" :id="shellId">
      <div class="table-wrapper-scroll-y">
        <table class="table table-striped table-bordered table-condensed vm-detail-table-wrap">
          <thead>
            <tr>
              <th class="col-md-2 col-lg-2"><div class="text-center">Name</div></th>
              <th class="col-md-1 col-lg-1"><div class="text-center">Status</div></th>
              <th class="col-md-1 col-lg-1 hidden-tablet"><div class="text-center">CPU</div></th>
              <th class="col-md-1 col-lg-1 hidden-tablet"><div class="text-center">Memory</div></th>
              <th class="col-md-1 col-lg-1 hidden-note"><div class="text-center">Boot</div></th>
              <th class="col-md-1 col-lg-1 hidden-phone"><div class="text-center">Network</div></th>
              <th class="col-md-1 col-lg-1"><div class="text-center">Owner</div></th>
              <th class="col-md-4 col-lg-4"><div class="text-center">Operation</div></th>
              <th class="col-md-1 col-lg-1"><div class="text-center">Migration</div></th>
              <th class="col-md-1 col-lg-1 hidden-phone"><div class="text-center">Comment</div></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="row in data.rows || []" :key="`vm-${row.id}`" :id="`vm-row-${row.id}`">
              <td v-html="row.name_html"></td>
              <td class="text-center">
                <span class="app-status-chip" :class="row.state_class">{{ row.state_label }}</span>
              </td>
              <td class="hidden-tablet"><div class="text-center">{{ row.vcpu }}</div></td>
              <td class="hidden-tablet"><div class="text-center">{{ row.memory }}</div></td>
              <td class="hidden-note"><div class="text-center">{{ row.boot }}</div></td>
              <td class="hidden-phone"><div class="text-center">{{ row.network }}</div></td>
              <td><div class="text-center" v-html="row.owner_html"></div></td>
              <td class="nopadding" v-html="row.operation_html"></td>
              <td v-html="row.migration_html"></td>
              <td class="hidden-phone"><div class="text-center">{{ row.comment }}</div></td>
            </tr>
          </tbody>
        </table>
      </div>

      <aside
        :id="`${shellId}-panel`"
        class="vm-detail-panel"
        aria-hidden="true"
        data-vue-component="vm-detail-panel"
        :data-vue-props="JSON.stringify({ shellId })"
      ></aside>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ rows: [], pagination_html: '', shell_id: 'vm-detail-shell', heading: 'Virtual Machines' })
  }
})

const data = ref(props.initialData || { rows: [], pagination_html: '', shell_id: 'vm-detail-shell', heading: 'Virtual Machines' })
const shellId = computed(() => data.value.shell_id || 'vm-detail-shell')
const heading = computed(() => data.value.heading || 'Virtual Machines')

function handleUpdate(event) {
  data.value = event.detail || { rows: [], pagination_html: '', shell_id: 'vm-detail-shell', heading: 'Virtual Machines' }
}

function mountNestedVue() {
  if (window.sccMountVueComponents) {
    window.sccMountVueComponents()
  }
}

onMounted(() => {
  document.addEventListener('scc:vm-list-results:update', handleUpdate)
  nextTick(mountNestedVue)
})

onBeforeUnmount(() => {
  document.removeEventListener('scc:vm-list-results:update', handleUpdate)
})

watch(data, () => {
  nextTick(mountNestedVue)
})
</script>
